import { toast } from '@buffer-mono/popcorn'

/**
 * Shared outcome returned by the saved-view mutation hooks when the current
 * organization id is missing. Matches the shape of `useTypedMutation`'s
 * not-success branch so callers can treat it identically.
 */
export function missingOrganizationOutcome(): {
  success: false
  error: { __typename: 'MutationError'; message: string }
  data: null
  loading: false
} {
  const error = {
    __typename: 'MutationError' as const,
    message: 'Organization not available',
  }
  toast.error(error.message)
  return { success: false, error, data: null, loading: false }
}
